module.exports = __webpack_public_path__ + "../resources/images/illustration_junk-a397acb5139710fa825c0cf9ed821f33.svg";